(function () {
    'use strict';

    angular.module('sempraWebapp').factory('CreateUpdateUserGroupViewModel', CreateUpdateUserGroupViewModelFactory);

    /** @ngInject */
    function CreateUpdateUserGroupViewModelFactory(sempraUsersActions, $translate) {
        function CreateUpdateUserGroupViewModel(id) {
            this.title = '';
            this.isEditMode = id ? true : false;

            //group fields
            this.id = id;
            this.groupName = '';
            this.groupType = 'DEFAULT';
            this.groupTypes = [];

            //search users related fields
            this.searchUserText = '';
            this.selectedUser = null;
            this.addUserEnabled = false;

            //search users by telephone related fields
            this.searchByTelephoneText = '';
            this.selectedUserByTelephone = null;
            this.addUserByTelephoneEnabled = false;

            //users grid fields
            this.groupUsers = [];
            this.usersPage = 1;
            this.usersTotal = 0;
            this.usersPageSize = 10;
            this.usersPageOptions = [5, 10, 15];
            this.usersOrderBy = 'user.firstName';
            this.usersOrder = 'asc';
            this.pagerTranslations = {
                page: $translate.instant('GRID_PAGER_PAGE'),
                rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
                of: $translate.instant('GRID_PAGER_PAGE_OF')
            };
            this.selectedGroupUsers = [];

            init.call(this);
        }

        CreateUpdateUserGroupViewModel.prototype.destroy = function () {
        };

        CreateUpdateUserGroupViewModel.prototype.setGroupId = function (id) {
            this.id = id;
            this.isEditMode = this.id ? true : false;
        };

        CreateUpdateUserGroupViewModel.prototype.refreshGroup = function (groupJson) {
            this.groupName = groupJson.name;
            this.groupType = groupJson.groupType;
        };

        CreateUpdateUserGroupViewModel.prototype.refreshUsersForGroup = function (usersJson) {
            this.groupUsers = usersJson.content;
            this.usersTotal = usersJson.totalElements;
        };

        CreateUpdateUserGroupViewModel.prototype.removeUser = function (index) {
            this.groupUsers.splice(index, 1);
        };

        CreateUpdateUserGroupViewModel.prototype.searchUser = function () {
            if (this.searchUserText !== '') {
                return sempraUsersActions.searchSempraUsers(this.searchUserText);
            }
        };

        CreateUpdateUserGroupViewModel.prototype.onSearchUserSelected = function () {
            this.addUserEnabled = this.selectedUser ? true : false;
        };

        CreateUpdateUserGroupViewModel.prototype.searchSempraUsersByTelephone = function () {
            if (this.searchByTelephoneText !== '') {
                return sempraUsersActions.searchSempraUsersByTelephone(this.searchByTelephoneText);
            }
        };

        CreateUpdateUserGroupViewModel.prototype.onSearchUserByTelephoneSelected = function () {
            this.addUserByTelephoneEnabled = this.selectedUserByTelephone ? true : false;
        };

        CreateUpdateUserGroupViewModel.prototype.onUserAddedToGroup = function () {
            this.selectedUser = null;
            this.searchUserText = '';
            this.addUserEnabled = false;
        };

        CreateUpdateUserGroupViewModel.prototype.onUserByTelephoneAddedToGroup = function () {
            this.selectedUserByTelephone = null;
            this.searchByTelephoneText = '';
            this.addUserByTelephoneEnabled = false;
        };

        CreateUpdateUserGroupViewModel.prototype.onUsersPaginationChange = function (page, limit) {
            this.usersPage = page;
            this.usersPageSize = limit;
            this.onUsersOrderingChange(this.usersOrderBy);
        };

        CreateUpdateUserGroupViewModel.prototype.onUsersOrderingChange = function (order) {
            var orderQuery = getOrderObject(order);
            this.usersOrderBy = orderQuery.orderBy;
            this.usersOrder = orderQuery.order;
        };

        return CreateUpdateUserGroupViewModel;

        function init() {
            if (this.isEditMode) {
                this.title = $translate.instant('BREAD_CRUMBS_EDIT_USER_GROUP');
            } else {
                this.title = $translate.instant('BREAD_CRUMBS_NEW_USER_GROUP');
            }
        }

        function getOrderObject(order) {
            var result = {
                order: 'asc',
                orderBy: order
            };

            if (order.indexOf('-') > -1) {
                result.order = 'desc';
                result.orderBy = order.substring(1);
            }

            return result;
        }
    }
})();
